import { render, staticRenderFns } from "./appTelegramButton.vue?vue&type=template&id=2fb0d824"
import script from "./appTelegramButton.vue?vue&type=script&lang=js"
export * from "./appTelegramButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports